module.exports = __webpack_public_path__ + "img/12.520507f2.svg";